import React from 'react';
import classNames from 'classnames';

import { Chevron } from 'components/Icons/Chevron';
import { Popup } from 'components/Map';
import WavetrakLink from 'components/WavetrakLink';
import type { NearbyStation } from 'types/buoys';
import { getBuoyReportPath } from 'utils/urls';

import styles from './BuoyMarkerPopup.module.scss';

interface Props {
  buoy: NearbyStation;
}

const subtitleClass = (status: NearbyStation['status']) =>
  classNames({
    [styles.buoyMarkerPopupContentSubtitle]: true,
    [styles.buoyMarkerPopupContentSubtitleOffline]: status === 'OFFLINE',
  });

const BuoyMarkerPopup: React.FC<Props> = ({ buoy }) => (
  <Popup>
    <section className={styles.buoyMarkerPopupContent}>
      <div className={styles.buoyMarkerPopupContentTitleContainer}>
        <WavetrakLink
          href={getBuoyReportPath({
            name: buoy.name,
            id: buoy.id,
            sourceID: buoy.sourceId,
          })}
          className={styles.buoyMarkerPopupContentLink}
        >
          <h1 className={styles.buoyMarkerPopupContentTitle}>{buoy.name}</h1>
          <Chevron direction="right" />
        </WavetrakLink>
      </div>
      <span className={subtitleClass(buoy.status)}>
        {buoy.status === 'ONLINE' ? (
          buoy.sourceId
        ) : (
          <>
            Status:
            <span className={styles.buoyMarkerPopupContentOfflineSubtitle}>{' Offline'}</span>
          </>
        )}
      </span>
    </section>
  </Popup>
);

export default React.memo(BuoyMarkerPopup);
